exports.parse = require('./lib/parse');
exports.stringify = require('./lib/stringify');



/*****************
 ** WEBPACK FOOTER
 ** /Users/bvaughn/Documents/git/react-devtools/~/jsonify/index.js
 ** module id = 384
 ** module chunks = 0
 **/